// extracted by mini-css-extract-plugin
module.exports = {"container":"e_GI","imageContainer":"e_HI","image":"e_II","content":"e_JI","category":"e_KI","title":"e_LI","author":"e_MI","titleContainer":"e_NI"};